import { Card, CardContent } from "@/components/ui/card";
import { PROPOSAL_TEXT } from "@/lib/proposalTheme";

type Props = {
  title?: string;
  description?: string;
  footnote?: string;
};

export default function ProposalApprovalPreview({
  title = "Approval & next step",
  description = "Customer approval and Portal proposal creation are coming in the next phase. This preview shows how the proposal will read once published.",
  footnote = "Preview only — not sent to customer",
}: Props) {
  return (
    <Card className="border-dashed border-[#1A2744]/20 bg-white/60">
      <CardContent className="space-y-2 py-6 text-center">
        <p className="text-sm font-medium" style={{ color: PROPOSAL_TEXT }}>
          {title}
        </p>
        <p className="mx-auto max-w-md text-sm leading-relaxed text-[#1A2744]/70">{description}</p>
        <p className="text-xs uppercase tracking-[0.14em] text-[#1A2744]/45">{footnote}</p>
      </CardContent>
    </Card>
  );
}
